window.smoothScroll = function(target) {
    var targetY = target.getBoundingClientRect().top + window.pageYOffset;
    function scrollToTarget(startY, endY, duration) {
        var startTime = performance.now();
        function scrollStep(currentTime) {
            var timeElapsed = currentTime - startTime;
            var progress = Math.min(timeElapsed / duration, 1);
            var easeInOutQuad = progress < 0.5 ? 2 * progress * progress : -1 + (4 - 2 * progress) * progress;

            window.scrollTo(0, startY + (endY - startY) * easeInOutQuad);

            if (timeElapsed < duration) {
                requestAnimationFrame(scrollStep);
            }
        }
        requestAnimationFrame(scrollStep);
    }
    scrollToTarget(window.pageYOffset, targetY, 600);
}
